// status message
export const UI_FIELD_STATUS_MESSAGE_PROOF_TYPE = 'proofType';
// references
export const UI_FIELD_REFERENCE = 'reference';
export const UI_FIELD_REFERENCES = 'references';
